import { Box } from 'grommet'
import styled from 'styled-components'

export const Wrapper = styled(Box)`
  .header-description {
    ${({ theme }) => theme.below.laptopML`
      max-width: ${({ theme }) => theme.maxWidth[0] + theme.maxWidth[2]}px;
    `}

    ${({ theme }) => theme.below.laptop`
      max-width: unset;
    `}
  }
`
